import React, { useState } from 'react';
import { login, register } from '../lib/api';

export default function LoginScreen({ onAuthenticated }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [isSignUp, setIsSignUp] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const data = isSignUp ? await register(username, password) : await login(username, password);
      onAuthenticated(data);
    } catch (err) {
      if (err.message === 'Backend unavailable') {
        setError('Server not running. Start with: ./start.sh');
      } else {
        setError(err.message || (isSignUp ? 'Registration failed' : 'Invalid credentials'));
      }
    } finally {
      setLoading(false);
    }
  };

  const inputStyle = {
    width: '100%',
    padding: '12px 16px',
    background: '#F5F5F5',
    border: '1px solid #E5E5E5',
    borderRadius: '4px',
    fontSize: '14px',
    fontFamily: "'IBM Plex Mono', monospace",
    color: '#1A1A1A',
    boxSizing: 'border-box',
    transition: 'border-color 0.15s',
  };

  const canSubmit = username.trim().length >= 2 && password.length >= (isSignUp ? 12 : 4);

  return (
    <div style={{
      minHeight: '100vh',
      background: '#FCFCFC',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontFamily: "'Outfit', sans-serif",
    }}>
      <div style={{
        width: '100%',
        maxWidth: '400px',
        padding: '48px 40px',
        background: '#FFFFFF',
        border: '1px solid #E5E5E5',
        borderRadius: '8px',
      }}>
        {/* Logo */}
        <div style={{ textAlign: 'center', marginBottom: '40px' }}>
          <h1 style={{
            fontSize: '32px',
            fontWeight: 700,
            color: '#1A1A1A',
            letterSpacing: '-0.02em',
            margin: 0,
          }}>
            Miner<span style={{ color: '#92700C' }}>Ops</span>
          </h1>
          <p style={{
            fontSize: '13px',
            color: '#737373',
            marginTop: '8px',
            letterSpacing: '0.08em',
            textTransform: 'uppercase',
          }}>
            Mining Strategy Platform
          </p>
        </div>

        {/* Gold accent bar */}
        <div style={{
          width: '48px',
          height: '3px',
          background: '#92700C',
          margin: '0 auto 32px',
          borderRadius: '2px',
        }} />

        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: '16px' }}>
            <label style={{
              display: 'block',
              fontSize: '11px',
              color: '#525252',
              textTransform: 'uppercase',
              letterSpacing: '0.08em',
              marginBottom: '8px',
            }}>
              Username
            </label>
            <input
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="Enter username"
              autoFocus
              autoComplete="username"
              style={inputStyle}
              onFocus={(e) => e.target.style.borderColor = '#92700C'}
              onBlur={(e) => e.target.style.borderColor = '#E5E5E5'}
            />
          </div>

          <div style={{ marginBottom: '20px' }}>
            <label style={{
              display: 'block',
              fontSize: '11px',
              color: '#525252',
              textTransform: 'uppercase',
              letterSpacing: '0.08em',
              marginBottom: '8px',
            }}>
              Password
            </label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder={isSignUp ? 'Create password (12+ chars)' : 'Enter password'}
              autoComplete={isSignUp ? 'new-password' : 'current-password'}
              style={inputStyle}
              onFocus={(e) => e.target.style.borderColor = '#92700C'}
              onBlur={(e) => e.target.style.borderColor = '#E5E5E5'}
            />
          </div>

          {error && (
            <div style={{
              padding: '10px 14px',
              background: '#FEF2F2',
              border: '1px solid #FECACA',
              borderRadius: '4px',
              fontSize: '13px',
              color: '#DC2626',
              marginBottom: '20px',
            }}>
              {error}
            </div>
          )}

          <button
            type="submit"
            disabled={loading || !canSubmit}
            style={{
              width: '100%',
              padding: '12px',
              background: loading || !canSubmit ? '#E5E5E5' : '#1A1A1A',
              color: loading || !canSubmit ? '#737373' : '#FCFCFC',
              border: 'none',
              borderRadius: '4px',
              fontSize: '14px',
              fontWeight: 600,
              fontFamily: "'Outfit', sans-serif",
              cursor: loading || !canSubmit ? 'not-allowed' : 'pointer',
              letterSpacing: '0.04em',
              transition: 'background 0.15s',
            }}
            onMouseEnter={(e) => {
              if (!loading && canSubmit) e.target.style.background = '#333333';
            }}
            onMouseLeave={(e) => {
              if (!loading && canSubmit) e.target.style.background = '#1A1A1A';
            }}
          >
            {loading ? 'Please wait...' : (isSignUp ? 'Create Account' : 'Sign In')}
          </button>
        </form>

        <div style={{ textAlign: 'center', marginTop: '20px' }}>
          <button
            onClick={() => { setIsSignUp(!isSignUp); setError(''); }}
            style={{
              background: 'none',
              border: 'none',
              color: '#92700C',
              fontSize: '13px',
              cursor: 'pointer',
              fontFamily: "'Outfit', sans-serif",
              textDecoration: 'underline',
              textUnderlineOffset: '2px',
            }}
          >
            {isSignUp ? 'Already have an account? Sign in' : 'New user? Create account'}
          </button>
        </div>

        <p style={{
          textAlign: 'center',
          fontSize: '11px',
          color: '#CCCCCC',
          marginTop: '32px',
        }}>
          MinerOps &copy; {new Date().getFullYear()}
        </p>
      </div>
    </div>
  );
}
